import {Component, OnInit} from '@angular/core';
import {UserService} from '../services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Version} from '../model/version.class';
import {Modal} from 'angular2-modal/plugins/bootstrap';
import {OrganisationUnit} from '../model/organisationUnit.class';

@Component({
    selector: 'app-version-detail',
    templateUrl: './version.detail.component.html'
})
export class VersionDetailComponent implements OnInit {

    public version: Version;
    public message = '';
    public uploadMessage = '';
    public duplicateMessage = '';
    public publishMessage: string[];
    public instance = this;
    public organisationUnits: OrganisationUnit[];
    public pageNumber: number;
    public duplicateUnit: OrganisationUnit;
    public duplicateMid: string;
    public speakers;
    public selectedSpeaker: string;
    public storyboardUploadSuccessful = false;
    public mediaUploadSuccessful = false;
    public mediaPublishSuccessful = true;
    // Der Duplizierbutton ist am Anfang disabled, da noch keine Seite zum Duplizieren ausgewählt wurde
    disableButtonDuplicate = true;
    disableButtonSpeaker = true;

    // tslint:disable-next-line:max-line-length
    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router, public modal: Modal) {
        this.route.params.subscribe(
            (params) => {
                userService.get(params['id'], 'version').subscribe(
                    (data) => {
                        this.version = data as Version;
                        this.transformSpeakers();
                        this.userService.getBy('organisationUnit', this.version.versionId, 'version').subscribe(
                            (data2) => {
                                this.organisationUnits = data2 as OrganisationUnit[];
                                for (const organisationUnit of this.organisationUnits) {
                                    if (organisationUnit.comment === null) {
                                        organisationUnit.comment = '';
                                    }
                                }
                            }
                        );
                    }
                );
            }
        );
    }

    transformSpeakers() {
        this.speakers = new Array();
        for (const speaker of this.version.speakers) {
            if (speaker.startsWith('-1')) {
                continue;
            }
            this.speakers.push(speaker.split(';'));
        }
    }

    lock() {
        this.version.versionStatus = this.userService.None;
        this.userService.update(this.version, 'version').subscribe();
    }

    approve() {
        this.version.versionStatus = this.userService.Approved;
        this.userService.update(this.version, 'version').subscribe();
    }

    addPage() {
        this.modal.confirm()
            .size('sm')
            .isBlocking(true)
            .showClose(true)
            .keyboard(27)
            .titleHtml('Neue Organisationseinheit anlegen?')
            .cancelBtn('Abbrechen')
            .open().then((resultPromise) => {
            return resultPromise.result.then(
                (result) => {
                    this.userService.create(this.version, 'organisationUnit/blanco/0').subscribe(
                        (data) => {
                            const unitId = data as Number;
                            window.open('./GrafischeEntwicklung/mrge.html?id=' + unitId
                                + '&jwt=Bearer ' + localStorage.getItem('token'), '_blank');
                            this.router.navigate(['media/detail', this.version.media.mediaId]);
                        }
                    );
                },
                () => {
                });
        });
    }

    delete() {
        this.modal.confirm()
            .size('sm')
            .isBlocking(true)
            .showClose(true)
            .keyboard(27)
            .titleHtml('Version wirklich löschen?')
            .cancelBtn('Abbrechen')
            .open().then((resultPromise) => {
            return resultPromise.result.then(
                (result) => {
                    this.userService.delete(this.version.versionId, 'version').subscribe(
                        (data) => this.router.navigate(['publisher/list']),
                        (err) => this.message = 'Löschen fehlgeschlagen!'
                    );
                },
                () => {
                });
        });
    }

    // Sobald eine Seite zum Duplizieren ausgewählt wurde, wird der DuplizierButton auf disabled = false gesetzt
    choosePage() {
        this.disableButtonDuplicate = false;
    }

    chooseSpeaker() {
        this.disableButtonSpeaker = false;
    }

    duplicate() {
        if (!this.duplicateMid || this.duplicateMid === '') {
            this.userService.get(this.duplicateUnit.organisationUnitId, 'organisationUnit/duplicate').subscribe(
                (data) => {
                    this.router.navigate(['media/detail', this.version.media.mediaId]);
                }
            );
        } else {
            if (isNaN(parseInt(this.duplicateMid))) {
                this.showModalMessage('Seite duplizieren', 'Bitte geben Sie eine valide MID ein!')
                return;
            }
            this.userService.getBy(this.duplicateMid, this.duplicateUnit.organisationUnitId, 'organisationUnit/duplicate').subscribe(
                (data) => {
                    this.duplicateMessage = 'Die Seite wurde erfolgreich in das Medium ' + this.duplicateMid + ' kopiert';
                    this.duplicateMid = '';
                },
                (error) => {
                    this.duplicateMessage = error._body;
                    this.duplicateMid = '';
                }
            );
        }
    }

    downloadSpeaker() {
        const jwt = localStorage.getItem('token');
        window.location.href = '/api/version/' + this.version.versionId + '/exportSpeakers/' + 'Bearer ' + jwt + '/';
    }

    downloadStoryboard() {
        const jwt = localStorage.getItem('token');
        window.location.href = '/api/version/' + this.version.versionId + '/exportStoryboard/' + 'Bearer ' + jwt + '/';
    }

    downloadSpeakerTasks() {
        console.log('Sprecher ausgewählt' + this.selectedSpeaker);
        const jwt = localStorage.getItem('token');
        window.location.href = '/api/version/' + this.version.versionId + '/exportSpeakerTasks/' + this.selectedSpeaker + '/Bearer ' + jwt + '/';
    }

    publishVersion() {
        this.createKiiFile(true);
    }

    download() {
        if (this.version.versionStatus === this.userService.Approved || this.version.externalVersion) {
            this.downloadKiiFile();
        } else {
            this.createKiiFile(false);
        }
    }

    // Die kii Datei wird im Backend erstellt. Soll die Version zusaätzlich veröffentlicht werden, wird der Versionsstatus geändert
    createKiiFile(publish: boolean) {
        const arraySplit = ';';
        if (publish) {
            this.publishMessage = ['Medium wird veröffentlicht.'];
        } else {
            this.publishMessage = ['kii Datei wird erstellt. '];
        }
        this.publishMessage.push('Dies kann je nach Größe des Mediums einige Sekunden bis Minuten dauern...');

        // Kii Datei wird erstellt
        this.userService.publish(this.version.versionId).subscribe(
            (data) => {
                // Kii wurde erfolgreich erstellt
                if (publish) {
                    // Version wird veröffentlicht (Status ändern)
                    this.version.versionStatus = this.userService.Approved;
                    this.userService.update(this.version, 'version').subscribe(
                        // Änderung des Versionsstatus erfolgreich
                        (data) => {
                            this.publishMessage = ['Veröffentlichung der Version erfolgreich'];
                        },
                        // Änderung des Versionsstatus fehlgeschlagen
                        (err2) => {
                            this.mediaPublishSuccessful = false;
                            this.publishMessage = ['Veröffentlichung der Version gescheitert'];
                            var errorArray = err2._body.split(arraySplit);
                            this.publishMessage = this.publishMessage.concat(errorArray);
                        }
                    );
                } else {
                    // Kii Datei wird heruntergeladen
                    this.downloadKiiFile();
                }
                // Anzeigen der Info zur erstellten kii Datei
                this.publishMessage = ['Erstellung der kii Datei erfolgreich!'];
                var infoArray = data._body.split(arraySplit);
                this.publishMessage = this.publishMessage.concat(infoArray);
            },
            (err) => {
                // Erstellung der kii fehlgeschlagen
                this.mediaPublishSuccessful = false;
                this.publishMessage = ['Erstellung der kii Datei gescheitert!'];
                var errorArray = err._body.split(arraySplit);
                this.publishMessage = this.publishMessage.concat(errorArray);
            }
        );
    }

    downloadKiiFile() {
        let midAsString = String(this.version.media.mid);
        while (midAsString.length < 5) {
            midAsString = '0' + midAsString;
        }
        const fileName = midAsString + '_' + this.version.media.bookAreaCode + '.kii';
        window.location.href = UserService.streamingServerUrl + '/' + this.version.media.publisher.publisherId + '/' + this.version.media.mid + '/' + this.version.number + '/' + fileName, "_blank";
    }

    uploadStoryboard() {
        if (this.userService.storyboardUploader.queue.length < 1) {
            this.showModalMessage('Keine Datei ausgewählt!', 'Bitte wählen Sie eine Datei zum Hochladen aus');
            return;
        }
        let error = true;
        for (const item of this.userService.storyboardUploader.queue) {
            if (item.file.name.endsWith('.csv') || item.file.name.endsWith('.txt')) {
                error = false;
            }
        }
        if (error) {
            this.showModalMessage('Falsches Dateiformat', 'Nur .csv und.txt Dateien dürfen hochgeladen werden');
            this.userService.storyboardUploader.clearQueue();
            return;
        }
        this.userService.uploadStoryboard(this.version.versionId);

        this.userService.storyboardUploader.onSuccessItem = (item, response, status, headers) => {
            if (status === 200) {
                if (response) {
                    this.uploadMessage = 'Fehler bei OID ' + response + '! Storyboard konnte nicht hochgeladen werden.'
                } else {
                    this.storyboardUploadSuccessful = true;
                    this.uploadMessage = 'Storyboard wurde erfolgreich hochgeladen'
                }
            } else {
                console.log(response);
                this.uploadMessage = 'Fehler beim Hochladen des Storyboards!';
            }
        };
        this.userService.storyboardUploader.onErrorItem = (item, response, status, headers) => {
            this.uploadMessage = 'Fehler beim Hochladen des Storyboards!';
            console.log(response);
        };
    }

    uploadMedias(): void {
        if (this.userService.zipUploader.queue.length < 1) {
            this.showModalMessage('Keine Datei ausgewählt!', 'Bitte wählen Sie eine Datei zum Hochladen aus');
            return;
        }
        let error = false;
        for (const item of this.userService.zipUploader.queue) {
            if (!item.file.name.endsWith('.zip')) {
                error = true;
            }
        }
        if (error) {
            this.showModalMessage('Falsches Dateiformat', 'Nur .zip Dateien dürfen hochgeladen werden')
            this.userService.zipUploader.clearQueue();
            return;
        }
        this.message = 'Upload ist in Arbeit, bitte warten';
        this.userService.uploadMedias(this.version.versionId, this);
    }

    saveVersionComment(): void {
        this.userService.update(this.version, 'version').subscribe();
    }

    downloadScreenshots() {
        const jwt = localStorage.getItem('token');
        window.open('/api/version/screenshots/' + this.version.versionId + '/Bearer ' + jwt + '/', '_blank');
    }

    ngOnInit(): void {
    }

    showModalMessage(title: string, message: string): void {
        this.modal.alert()
            .size('sm')
            .isBlocking(true)
            .showClose(true)
            .keyboard(27)
            .titleHtml(title)
            .message(message)
            .open();
    }
}



// WEBPACK FOOTER //
// ./src/app/versionDetail/version.detail.component.ts